import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { WithdrawalpointPage } from './withdrawalpoint';

@NgModule({
  declarations: [
    WithdrawalpointPage,
  ],
  imports: [
    IonicPageModule.forChild(WithdrawalpointPage),
  ],
})
export class WithdrawalpointPageModule {}



// WEBPACK FOOTER //
// ./src/pages/withdrawalpoint/withdrawalpoint.module.ts